import { create } from 'zustand';

interface GlobalState {
  shiftCanvas: boolean;
  setShiftCanvas: (value: boolean) => void;
}

export const useGlobalState = create<GlobalState>(set => ({
  shiftCanvas: false,
  setShiftCanvas: (value: boolean) => set({ shiftCanvas: value }),
}));
